export interface CsvExportOptions {
  heading?: string
  description?: string
  timestamp?: string
  filenamePrefix?: string
  includeMessageId?: string
}

function getTimestamp(): string {
  return new Date().toISOString().replace(/[:T]/g, '-').slice(0, 19)
}

function escapeCsv(text: string): string {
  return text.replace(/"/g, '""')
}

export function toCsvContentFromTables(
  tables: HTMLTableElement[],
  options: CsvExportOptions = {},
): {
  csvContent: string
  timestamp: string
} {
  const timestamp = options.timestamp || getTimestamp()

  const csvRows: string[] = []
  if (options.heading) {
    csvRows.push(`"${options.heading}"`)
  }
  if (options.description) {
    csvRows.push(`"${options.description}"`)
    csvRows.push('')
  }
  if (!tables.length) {
    return { csvContent: csvRows.join('\r\n'), timestamp }
  }

  tables.forEach((table) => {
    const rows = Array.from(table.querySelectorAll('tr'))
    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll('th, td'))
      const line = cells
        .map((cell) => {
          const text = (cell.textContent || '').trim()
          return `"${escapeCsv(text)}"`
        })
        .join(',')
      csvRows.push(line)
    })
    csvRows.push('')
  })

  return { csvContent: csvRows.join('\r\n'), timestamp }
}

function downloadCsv(csvContent: string, filename: string): void {
  const BOM = '\ufeff'
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

export function exportElementTablesToCsv(root: Element, options: CsvExportOptions = {}): void {
  if (!root) return
  const tables = Array.from(root.querySelectorAll('table')) as HTMLTableElement[]
  const { csvContent, timestamp } = toCsvContentFromTables(tables, options)
  const filenamePrefix = options.filenamePrefix || 'al-agent-response'
  downloadCsv(csvContent, `${filenamePrefix}-${timestamp}.csv`)
}
